import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=6b6f748b&"
import script from "./notification.vue?vue&type=script&lang=ts&"
export * from "./notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6f748b')) {
      api.createRecord('6b6f748b', component.options)
    } else {
      api.reload('6b6f748b', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=6b6f748b&", function () {
      api.rerender('6b6f748b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/utilities/notification.vue"
export default component.exports